import React, { useContext, useEffect, useState } from "react";
import secondaryComponents from "../../../../../components/secondaryComponents";
import primaryComponents from "../../../../../components/primaryComponents";
import { motion } from "framer-motion";
import styles from "./styles.module.scss";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import ApiManagement from "../ApiManagement";
import { pathConstants } from "../../../../../routes/pathContants";
import { useNavigate, useSearchParams } from "react-router-dom";
import ChowdeckConnectStore from "../ConnectStore";
import { ToastContext } from "../../../../../hooks/context";
import { useMutation } from "react-query";
import {
  createConnection,
  marketPlaceProductsMapping,
} from "../../../../../services/marketplace";

const SetupFlow = () => {
  const navigate = useNavigate();
  const triggerToast = useContext(ToastContext);
  const [search, setSearch] = useSearchParams();

  const [currentStep, setCurrentStep] = useState(0);
  const [chowdeckSecretKey, setChowdeckSecretKey] = useState("");
  const [chowdeckLumiConnections, setChowdeckLumiConnections] = useState([]);

  const connection_id = search.get("id");
  const mapping_id = search.get("mapping_id");

  const { isLoading, mutate, data } = useMutation({
    mutationFn: (data) => createConnection(data),
    onSuccess: (data) => {
      triggerToast(data.data.detail, "success");
      setCurrentStep(currentStep + 1);
    },
    onError: (error) => {
      triggerToast(`${error.response.data.message}`, "warning");
    },
  });

  const productsMapping = useMutation({
    mutationFn: (data) =>
      marketPlaceProductsMapping({
        data,
        queries: `?connection_id=${connection_id}`,
      }),
    onSuccess: (data) => {
      triggerToast(data.data.detail, "success");
      navigate(`${pathConstants.APPS_CHOWDECK_CONNECTIONS}`);
    },
    onError: (error) => {
      triggerToast(`${error.response.data.message}`, "warning");
    },
  });

  useEffect(() => {
    if (data) {
      search.set("id", data?.data?.data?.id);
      setSearch(search, { replace: true });
    }
  }, [data]);

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Chowdeck"
      description={"View and Manage Connections"}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.3 } }}
        className={`${globalStyles?.pagePaddings} ${globalStyles.pageColumnGaps}`}
      >
        <div className={styles.stepperCover}>
          <secondaryComponents.FormStepper
            currentStep={currentStep}
            naviagetToStep={(val) => setCurrentStep(val)}
            steps={[
              {
                id: 0,
                title: "API Management",
              },
              {
                id: 1,
                title: "Connect a Store & Manage Items",
              },
            ]}
          />
        </div>
        <div className={styles.mainContainer}>
          {currentStep === 0 ? (
            <ApiManagement
              chowdeckSecretKey={chowdeckSecretKey}
              setChowdeckSecretKey={setChowdeckSecretKey}
            />
          ) : (
            <ChowdeckConnectStore
              setChowdeckLumiConnections={setChowdeckLumiConnections}
            />
          )}
          <div className={styles.btnContainer}>
            <primaryComponents.Button
              classNames="btn btn--outline mt-auto"
              type="submit"
              isLoading={false}
              isDisabled={false}
              onClick={() => {
                if (currentStep === 0) {
                  return navigate(
                    pathConstants.APPS_DETAILS({ id: "chowdeck" }),
                  );
                }
                setCurrentStep(currentStep - 1);
              }}
            >
              Back
            </primaryComponents.Button>
            <primaryComponents.Button
              classNames="btn btn--primary mt-auto"
              type="submit"
              isLoading={isLoading || productsMapping.isLoading}
              isDisabled={
                isLoading ||
                productsMapping.isLoading ||
                (currentStep === 1 && chowdeckLumiConnections.length === 0)
              }
              onClick={() => {
                if (currentStep === 0) {
                  if (!chowdeckSecretKey) {
                    return triggerToast(
                      "Chowdeck API key is required to proceed",
                    );
                  }
                  mutate({ secret_key: chowdeckSecretKey, type: "CHOWDECK" });
                  return;
                } else {
                  const productIsUndefined = chowdeckLumiConnections.find(
                    (item) =>
                      item?.lumi_product?.product_id === undefined &&
                      item?.lumi_product?.service_id === undefined &&
                      item?.lumi_product?.variant_id === undefined,
                  );
                  if (productIsUndefined) {
                    triggerToast("Please select a lumi product to link with");
                    return;
                  }

                  productsMapping.mutate({
                    store_mapping_id: mapping_id,
                    product_mapping: chowdeckLumiConnections,
                  });
                }
              }}
            >
              Proceed
            </primaryComponents.Button>
          </div>
        </div>
      </motion.div>
    </secondaryComponents.MetaSetter>
  );
};

export default SetupFlow;
